<template>
    <div id="content">
      <div id="pageContent">
        <div class="pageHeader">
          <div class="white flex flex-column hcenter" style="font-family: TruenoBd;padding-left: 10%;height: 100%">
            <div class="pageTitle">关于我们</div>
            <div class="subPageTitle">/ABOUT US</div>
          </div>
        </div>
        <div id="yixi-nav" class="tabs flex vcenter hidden-xs">
          <div class="flex1 flex justify-spaceBetween nav-about">
            <!-- <a href="#company" class="tab pointer" @click="go('company')">公司介绍</a>
            <a href="#company" class="tab pointer" @click="go('develop')">发展历程</a>
            <a href="#company" class="tab pointer" @click="go('product')">生产基地</a>
            <a href="#company" class="tab pointer" @click="go('concact')">联系我们</a> -->
            <a href="#company" class="tab pointer" :class="{ 'active': activeName == 'company' }">公司介绍</a>
            <a href="#develop" class="tab pointer" :class="{ 'active': activeName == 'develop' }">发展历程</a>
            <a href="#product" class="tab pointer" :class="{ 'active': activeName == 'product' }">生产基地</a>
            <a href="#concact" class="tab pointer" :class="{ 'active': activeName == 'concact' }">联系我们</a>
          </div>
          <div class="flex1 t-right">
            <span>您的位置：</span>
            <a href="/">首页 </a>
            <span>&gt; 关于我们</span>
          </div>
        </div>
        <section>
          <div class="anmao" id="company"></div>
          <a class="title t-center">公司介绍</a>
          <div class="info" style="text-indent:32px;text-align:left">“天得一以清，地得一以宁，谷得一以盈，万物得一以生”。一兮生物亦欲以究生命之道，通进化之变，成造物之知。</div>
          <div class="info" style="text-indent:32px;text-align:left">一兮生物成立于2019年，是一家专注于合成生物学领域的技术与产品研发公司：</div>
          <div class="info" style="text-indent:32px;text-align:left"><span class="bold">以技术和创造力，拓展人类食物来源的边界。</span>我们以食品添加剂为切入点，建立多条研发管线。其中，我们在国内率先进行的HMO生物合成项目已实现产业化。</div>
          <div class="info" style="text-indent:32px;text-align:left"><span class="bold">以研究和想象力，探索生命体的新形式。</span>我们在进行产品开发的同时，不断进行底层技术和生命逻辑的探索，希冀能获得对生命新的理解和认知，在技术和产品上获得新突破。</div>
          
          <div class="mt4 company_sm_img flex hcenter vcenter hidden-xs">
            <div class="company-border flex vcenter hcenter mb2 mx2">
              <div class="shipin yixi-image"></div>
            </div>
            <div class="company-border flex vcenter hcenter mb2 mx2">
              <div class="yiyao yixi-image"></div>
            </div>
            <div class="company-border flex vcenter hcenter mb2 mx2">
              <div class="gongye yixi-image"></div>
            </div>
          </div>
          <div class="mt4 company flex hcenter vcenter">
            <div class="scale mr2 mb2 lap">
              <img src="../assets/about/lap01.png" alt="">  
            </div>
            <div class="scale mr2 mb2 lap">
              <img src="../assets/about/lap02.png" alt="">  
            </div>
          </div>
          <div class="company flex hcenter vcenter">
            <div class="scale mr2 mb2 lap">
              <img src="../assets/about/lap03.png" alt="">  
            </div>
            <div class="scale mr2 mb2 lap">
              <img src="../assets/about/lap04.png" alt="">  
            </div>
          </div>
        </section>
        <div class="anmao" id="develop"></div>
        <div id="develop" class="page_holder">
          <img class="hidden-md hidden-lg " src="../assets/about/about3.png" alt="" style="width: 100%">
          <img class="hidden-sm hidden-xs" src="../assets/about/fzlc.png" alt="" height="747" style="width: 100%">
          <div class="absolute fzlc-title hidden-sm hidden-xs">发展历程</div>
          <div class="path hidden-sm hidden-xs">
            <img src="../assets/about/path.png" alt="">
          </div>
          <div class="point hidden-sm hidden-xs">
            <div class="circle circle-1">
              <div class="flex hcenter flex-column date_line">
                <div class="date">2019年9月</div>
                <div class="thing">一兮生物成立</div>
              </div>
            </div>
            <div class="circle circle-2">
              <div class="flex hcenter flex-column date_line">
                <div class="date">2020年5月</div>
                <div class="thing">完成HMO项目小试</div>
              </div>
            </div>
            <div class="circle circle-3">
              <div class="flex hcenter flex-column date_line">
                <div class="date">2021年3月</div>
                <div class="thing">与乳企达成战略投资合作</div>
              </div>
            </div>
            <div class="circle circle-4">
              <div class="flex hcenter flex-column date_line">
                <div class="date">2021年4月</div>
                <div class="thing">完成HMO项目中试</div>
              </div>
            </div>
            <div class="circle circle-5">
              <div class="flex hcenter flex-column date_line">
                <div class="date">2021年5月</div>
                <div class="thing">完成生产基地签约仪式</div>
              </div>
            </div>
            <div class="circle circle-6">
              <div class="flex hcenter flex-column date_line">
                <div class="date">2021年6月</div>
                <div class="thing">完成天使轮融资</div>
              </div>
            </div>
            <div class="circle circle-7">
              <div class="flex hcenter flex-column date_line">
                <div class="date">2021年9月</div>
                <div class="thing">完成HMO项目模拟生产</div>
              </div>
            </div>
            <div class="circle circle-8">
              <div class="flex hcenter flex-column date_line">
                <div class="date">2021年11月</div>
                <div class="thing">完成preA轮融资</div>
              </div>
            </div>
            <div class="circle circle-9">
              <div class="flex hcenter flex-column date_line">
                <div class="date">2022年1月</div>
                <div class="thing">
                  <div>完成苏州研发中心建设</div>
                  <div>迁址苏州工业园区</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section>
          <div class="anmao" id="product"></div>
          <a id="product" class="title t-center">生产基地</a>
          <div class="info hidden-xs">
            <div>HMO生产基地于2021年5月完成基地签约仪式，占地面积100亩。</div>
            <div>拥有完善的产业化研究中心、自动化发酵中心、纯化中心和质检中心，是中国最早的HMO生产基地之一。</div>
          </div>
          <div class="info hidden-sm hidden-md hidden-lg">
            <div>HMO生产基地于2021年5月完成基地签约仪式，占地面积100亩。拥有完善的产业化研究中心、自动化发酵中心、纯化中心和质检中心，是中国最早的HMO生产基地之一。</div>
          </div>
          <div class="company flex hcenter vcenter mt4">
            <div class="scale mr2 area">
              <img src="../assets/about/area01.png" alt="">  
            </div>
            <div class="scale mr2 area">
              <img src="../assets/about/area02.png" alt="">  
            </div>
          </div>
        </section>
        <section>
          <div class="anmao" id="concact"></div>
          <a class="title t-center">联系我们</a>
          <div class="company map-info flex hcenter mt8">
            <div id="map" class="map mr2 flex-1">
              <iframe src="/static/map.html" width="100%" height="100%" frameborder="0" scrolling="no"></iframe>
            </div>
            <div class="mt2 flex-1">
              <div class="subtitle">一兮生物科技</div>
              <div class="desc flex mt2">
                <div class="mr1">〇 </div>
                <div>
                  <div>地址：苏州工业园区东长路88号2.5产业园</div>
                  <div>电话：<span class="phone">0512-62906278</span></div>
                  <div>邮箱：<span class="phone">office@yixilife.com</span></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
export default {
  name: 'About',
  created() {
    window.onscroll = () => {
      if ($('.path').width() == 0 && (document.documentElement.scrollTop > $('#company').offset().top)) {
        $('.path').animate({ width: '1006px' },3000,'linear');
        $('.circle-1').delay(100).fadeIn();
        $('.circle-2').delay(400).fadeIn();
        $('.circle-3').delay(900).fadeIn();
        $('.circle-4').delay(1100).fadeIn();
        $('.circle-5').delay(1300).fadeIn();
        $('.circle-6').delay(1700).fadeIn();
        $('.circle-7').delay(2100).fadeIn();
        $('.circle-8').delay(2500).fadeIn();
        $('.circle-9').delay(2800).fadeIn();
      }
    }
    this.$nextTick(_ => {
      this.handleResize();
    })
    window.addEventListener('resize', this.handleResize);
    // window.addEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      timer: null,
      topHeight: 499,
      activeName: 'company',
    }
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleScroll() {
      // let nav = document.getElementById("yixi-nav");
      let height = document.documentElement.scrollTop;
      // if (height - this.topHeight > 0) {
      //   if (nav) nav.classList.add("fixed-tab");
      // } else {
      //   if (nav) nav.classList.remove("fixed-tab");
      // }
      // 判断高亮
      let navs = ['company', 'develop', 'product', 'concact'];
      navs.forEach(item => {
        let nav_height = document.getElementById(item).offsetTop - 150;
        if (height > nav_height) {
          this.activeName = item;
        }
      })
    },
    handleResize() {
      if (document.documentElement.clientWidth < 1006) {
        return false;
      }
      if (document.documentElement.clientWidth < 1441) {
        $('.path').css({
          'left': document.documentElement.clientWidth / 2 - 503 + 'px'
        })
        $('.point').css({
          'left': document.documentElement.clientWidth / 2 - 503 + 'px'
        })
      } else {
        $('.path').css({
          'left': 'calc(50% - 503px)'
        })
        $('.point').css({
          'left': 'calc(50% - 503px)'
        })
      }
    },
    go(id) {
      // this.$nextTick(_ => {
      //   clearTimeout(this.timer);
      //   // 阻止handleScroll里的滚动高亮影响点击
      //   this.stop = true;
      //   //页面滚动了的距离
      //   let height = document.documentElement.scrollTop;

      //   //指定dom到页面顶端的距离
      //   let dom = document.getElementById(id);
      //   let domHeight = (height - this.topHeight > 0 || dom.offsetTop == (this.topHeight + 40)) ? dom.offsetTop - 40 : dom.offsetTop - 80;
      //   //dom.scrollIntoView();

      //   //滚动距离计算
      //   var S = Number(height) - Number(domHeight);

      //   //判断上滚还是下滚
      //   if (S < 0) {
      //     //下滚
      //     S = Math.abs(S);
      //     window.scrollBy({
      //       top: S,
      //       behavior: "smooth",
      //     });
      //   } else if (S == 0) {
      //     //不滚
      //     window.scrollBy({ top: 0, behavior: "smooth" });
      //   } else {
      //     //上滚
      //     S = dom.offsetTop == this.topHeight ? -S + 40 : -S;
      //     window.scrollBy({
      //       top: S,
      //       behavior: "smooth",
      //     });
      //   }
      //   this.timer = setTimeout(() => {
      //     this.stop = false;
      //   }, 1000)
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
    .pageHeader{
        overflow: hidden; width: 100%; height: 494px;
        background-image: url("../assets/about/about2.png");
        background-position: 50% 50%;
    }
    .title {
      display: block;
      font-size: 32px;
      font-weight: 600;
      color: #111D2B;
      line-height: 1;
    }
    .info {
      color: #111D2B;
      opacity: 0.5;
      font-weight: 400;
      font-size: 16px;
      text-align: center;
      line-height: 1.8;
      max-width: 845px;
      margin: 0 auto;
      margin-top: 21px;
    }
    .anmao{
      height: 0;
      position: relative;
      top: -80px;
    }
    .company-border {
      width: 216px;
      height: 180px;
      border: 1px solid #DEE1E3;
    }
    .shipin {
      width: 200px;
      height: 160px;
      background: url('~@/assets/about/shipin.svg') 50% 50% no-repeat no-repeat;
    }
    .yiyao {
      width: 200px;
      height: 160px;
      background: url('~@/assets/about/yiyao.svg') 50% 50% no-repeat no-repeat;
    }
    .gongye {
      width: 200px;
      height: 160px;
      background: url('~@/assets/about/gongye.svg') 50% 50% no-repeat no-repeat;
    }
    
    .lap {
      width: 100%;
      height: 372px;
      max-width: 566px;
    }
    .lap01 {
      background: url('~@/assets/about/lap01.png') 50% 50% no-repeat no-repeat;
    }
    .lap02 {
      background: url('~@/assets/about/lap02.png') 50% 50% no-repeat no-repeat;
    }
    .lap03 {
      background: url('~@/assets/about/lap03.png') 50% 50% no-repeat no-repeat;
    }
    .lap04 {
      background: url('~@/assets/about/lap04.png') 50% 50% no-repeat no-repeat;
    }
    .area {
      width: 100%;
      height: 372px;
      max-width: 566px;
    }
    .area01 {
      background: url('~@/assets/about/area01.png') 50% 50% no-repeat no-repeat;
    }
    .area02 {
      background: url('~@/assets/about/area02.png') 50% 50% no-repeat no-repeat;
    }
    @media screen and (max-width: 768px) {
      .company_sm_img {
        flex-direction: column;
      }
    }
    @media screen and (max-width: 960px) {
      .company {
        flex-direction: column;
      }
      .lap {
        margin: 16px 0;
      }
      .area {
        margin: 16px 0;
      }
      .map {
        margin: 16px 0;
      }
    }
    .subtitle {
      font-size: 22px;
      font-weight: 600;
    }
    .desc {
      font-size: 16px;
      color: #111D2B;
      line-height: 2;
      opacity: 0.5;
    }
    .phone {
      font-size: 20px;
    }
    .map {
      width: 100%;
      height: 372px;
      max-width: 728px;
    }
    @media screen and (max-width: 960px) {
      .map-info {
        align-items: center;
      }
    }
    .page_holder {
      position: relative;
      text-align: center;
      width: 100%;
      margin: 0 auto;
      color: #454545;
    }
    .fzlc {
      width: 100%;
      max-width: 1441px;
      height: 747px;
      background: url('~@/assets/about/fzlc.png') 50% 50% no-repeat no-repeat;
      position: relative;
    }
    .fzlc-title {
      top: 57px;
      font-weight: 600;
      font-size: 32px;
      width: 100%;
      color: #fff;
    }
    .path {
      position: absolute;
      width: 0;
      top: 280px;
      left: calc(50% - 503px);
      height: 450px;
    }
    .point {
      position: absolute;
      top: 280px;
      left: calc(50% - 503px);
      height: 450px;
      .circle {
        width: 21px;
        height: 21px;
        background: #293543;
        border: 3px solid #00BD89;
        border-radius: 50%;
      }
      .circle-1 {
        position: absolute;
        top: 188px;
        left: 60px;
        display: none;
      }
      .circle-2 {
        position: absolute;
        top: 147px;
        left: 157px;
        display: none;
      }
      .circle-3 {
        position: absolute;
        top: 146px;
        left: 337px;
        display: none;
      }
      .circle-4 {
        position: absolute;
        top: 167px;
        left: 431px;
        display: none;
      }
      .circle-5 {
        position: absolute;
        top: 170px;
        left: 520px;
        display: none;
      }
      .circle-6 {
        position: absolute;
        top: 153px;
        left: 612px;
        display: none;
      }
      .circle-7 {
        position: absolute;
        top: 107px;
        left: 696px;
        display: none;
      }
      .circle-8 {
        position: absolute;
        top: 50px;
        left: 780px;
        display: none;
      }
      .circle-9 {
        position: absolute;
        top: 9px;
        left: 870px;
        display: none;
      }
      .circle-1, .circle-3, .circle-5, .circle-7, .circle-9 {
        &::after {
          content: '';
          top: 20px;
          height: 100px;
          width: 1px;
          border: 1px dashed #fff;
          position: relative;
          display: inline-block;
          left: 1px;
          opacity: 0.5;
        }
        .date_line {
          top: 120px;
          left: -70px;
        }
      }
      .circle-2, .circle-4, .circle-6, .circle-8 {
        &::before {
          content: '';
          top: -104px;
          height: 100px;
          width: 1px;
          border: 1px dashed #fff;
          position: relative;
          display: inline-block;
          opacity: 0.5;
        }
        .date_line {
          top: -160px;
          left: -70px;
          
        }
      }
      .date_line {
        position: absolute;
        display: inline-block;
        width: max-content;
        color: #fff;
        line-height: 2;
        text-align: center;
        width: 154px;
        .thing {
          opacity: 0.5;
        }
      }
    }
    .fixed-tab {
      position: fixed;
      top: 76px;
      width: 100%;
      z-index: 2000;
    }
    @media screen and (max-width: 768px)  {
      .title {
        font-size: 32px;
      }
      .subtitle {
        font-size: 18px;
      }
      .desc {
        font-size: 14px;
      }
      .phone {
        font-size: 16px;
      }
      .info {
        text-align: left;
        text-indent: 32px;
      }
    }
    
</style>



// WEBPACK FOOTER //
// src/views/about.vue